import { lazy } from 'react';

const SalesJournal = lazy(() =>
  import('../pages/SalesJournal/Screens/SalesJournalScreen'),
);

const salesInvoiceRoute = {
  public: [],
  auth: [
    {
      name: 'sales_journal_lists',
      path: '/ledgers/internal-sales-journal',
      component: SalesJournal,
    },
  ],
};

export default salesInvoiceRoute;
